import React from 'react';

const Card = ({ children, className = '', style = {}, ...props }) => {
  const baseStyle = {
    backgroundColor: 'var(--color-bg-surface)',
    borderRadius: 'var(--radius-md)',
    padding: '24px',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    border: '1px solid var(--color-border)',
    ...style
  };

  return (
    <div className={className} style={baseStyle} {...props}>
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = '', style = {} }) => (
  <div 
    className={className}
    style={{
      marginBottom: '16px',
      paddingBottom: '16px',
      borderBottom: '1px solid var(--color-border)',
      ...style
    }}
  >
    {children}
  </div>
);

const CardTitle = ({ children, className = '', style = {} }) => (
  <h3 
    className={className}
    style={{
      fontSize: '18px',
      fontWeight: '600',
      color: 'var(--color-text-primary)',
      margin: 0,
      ...style
    }}
  >
    {children}
  </h3>
);

const CardContent = ({ children, className = '', style = {} }) => (
  <div className={className} style={style}>
    {children}
  </div>
);

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Content = CardContent;

export default Card;